export default "__VITE_ASSET__29c28680__"